"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PermissionCheck_1 = __importDefault(require("@Components/PermissionCheck"));
const permissions_1 = require("@Const/permissions");
const Button_1 = require("@Components/Buttons/Button");
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const OverclaimExportButton = (props) => {
    const { loading, setSidebarIsOpen } = props;
    return (react_1.default.createElement(PermissionCheck_1.default, { key: 'export_button', requiredPermissions: [permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.view_works] },
        react_1.default.createElement(Button_1.Button, { submitType: 'button', mainColor: true, type: "secondary", className: "export-search-button", disabled: loading, onClick: () => setSidebarIsOpen(true) }, "Export")));
};
exports.default = (0, mobx_react_1.observer)(OverclaimExportButton);
